module.exports = __webpack_public_path__ + "media/images/story/top/title_point-da9df6db1672b71853635b3a70dee2a9.jpg";